import { useState } from "react";
import FiltreProfile from "../FiltreProfile";
import gamesFeed from "../../utils/gamesFeed.json";
import "./GamesFeed.css";
import { Link } from "react-router-dom";

const GamesFeed = () => {
  const [openFiltre, setOpenfiltre] = useState(false);
  const [incompleteTeam, setIncompleteTeam] = useState(false);
  const [isTeam, setIsTeam] = useState(false);

  const handleJoinGame = () => {
    // check if it's solo
    if (isTeam) {
      /**
       * if the user join the team or not solo
       * make sure have 4 user in team if not showing the popup
       *
       * for now because this is just for design purpose and in development not in production
       * I just show the error or incomplete popup after that we can do the team user "join"
       */

      // if team not have 4 user in their team
      setIncompleteTeam(true);
    }
  };

  return (
    <div className="gamesFeed">
      <div className="gamesFeed__header flex-row">
        <h3>Games Feed</h3>
        <div className="gamesFeed__dropdownToggle flex-row">
          <input
            type="checkbox"
            // checked={darkMode}
            onChange={() => setIsTeam((isTeam) => !isTeam)}
            checked={isTeam}
            // onChange={() => setDarkMode((darkMode) => !darkMode)}
          />
          {/* <div
            className="gamesFeed__dropdownToggleIcon item-center rounded"
            // onClick={() => setDarkMode((darkMode) => !darkMode)}
          ></div> */}
          <span>Join Random</span>
          <span>Join With Team</span>
        </div>
        <div
          className="flex-row"
          onClick={() => setOpenfiltre((openFiltre) => !openFiltre)}
        >
          <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <path d="M37.1223 28.0391C40.9222 28.0391 44 31.0651 44 34.7984C44 38.5296 40.9222 41.5556 37.1223 41.5556C33.3245 41.5556 30.2445 38.5296 30.2445 34.7984C30.2445 31.0651 33.3245 28.0391 37.1223 28.0391ZM20.1666 31.9159C21.831 31.9159 23.1821 33.2433 23.1821 34.8786C23.1821 36.5116 21.831 37.8412 20.1666 37.8412H7.01554C5.3511 37.8412 4 36.5116 4 34.8786C4 33.2433 5.3511 31.9159 7.01554 31.9159H20.1666ZM10.8777 6C14.6777 6 17.7555 9.02597 17.7555 12.7571C17.7555 16.4905 14.6777 19.5164 10.8777 19.5164C7.07998 19.5164 4 16.4905 4 12.7571C4 9.02597 7.07998 6 10.8777 6ZM40.9867 9.79665C42.6489 9.79665 44 11.1241 44 12.7571C44 14.3924 42.6489 15.7198 40.9867 15.7198H27.8356C26.1712 15.7198 24.8201 14.3924 24.8201 12.7571C24.8201 11.1241 26.1712 9.79665 27.8356 9.79665H40.9867Z" />
          </svg>
          Filter
        </div>
      </div>
      <FiltreProfile openFiltre={openFiltre} />
      <div>
        {gamesFeed.map((game) => (
          <div className="gamesFeed__card flex-row" key={game.id}>
            <img
              src={game.img}
              alt={game.title}
              className="gamesFeed__cardUserImg"
            />
            <div className="gamesFeed__cardTitle flex-row">
              <div>
                <h3>{game.title}</h3>
                <div>
                  <span>
                    Postes by{" "}
                    <Link to={`/profile/${game.createdBy.split("/")[1]}`}>
                      {game.createdBy}
                    </Link>
                  </span>
                </div>
              </div>
              <div className="gamesFeed__team flex-row">
                {isTeam ? (
                  game.joins.teams.map((team) => (
                    <img src={team.img} alt={team.teamName} key={team.id} />
                  ))
                ) : (
                  <>
                    {game.joins.solos.map(
                      (solo, i) =>
                        i < 4 && (
                          <img
                            src={solo.user.img}
                            alt={solo.user.name}
                            key={solo.id}
                          />
                        )
                    )}
                    {game.joins.solos.length >= 4 && (
                      <div className="gamesFeed__moreParticipant">
                        +{game.joins.solos.length - 4}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="gamesFeed__minimalSection flex-column">
              <h4>Min Games</h4>
              <span className="gamesFeed__total">136</span>
            </div>
            <div className="gamesFeed__minimalSection flex-column">
              <h4>Min Ratings</h4>
              <span className="gamesFeed__total">2368</span>
            </div>
            <div className="flex-row" onClick={handleJoinGame}>
              Join the game
              <svg
                viewBox="0 0 20 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 3.5H19M19 3.5L15.5 1M19 3.5L15.5 6"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>
      {/* error popup or incompleted popup */}
      {incompleteTeam && (
        <div className="gamesFeed__errorPopup">
          <div className="gamesFeed__errorPopupContainer flex-column">
            <svg viewBox="0 0 182 170" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.13072 169.754H172.271C173.848 169.745 175.396 169.329 176.764 168.545C178.132 167.762 179.275 166.637 180.08 165.281C180.885 163.925 181.326 162.384 181.359 160.808C181.393 159.231 181.018 157.673 180.271 156.284L98.7407 4.80383C97.9593 3.35166 96.7993 2.13824 95.3837 1.29242C93.968 0.446597 92.3498 0 90.7007 0C89.0517 0 87.4334 0.446597 86.0178 1.29242C84.6022 2.13824 83.4421 3.35166 82.6608 4.80383L1.09074 156.284C0.342073 157.676 -0.0329574 159.238 0.00227177 160.818C0.037501 162.398 0.481771 163.941 1.29173 165.298C2.10169 166.655 3.24967 167.779 4.62358 168.56C5.99749 169.341 7.55039 169.752 9.13072 169.754ZM101.081 131.699C101.081 137.429 96.4307 142.074 90.7007 142.074V142.074C84.9708 142.074 80.3207 137.429 80.3207 131.699V131.699C80.3207 125.969 84.9708 121.324 90.7007 121.324V121.324C96.4307 121.324 101.081 125.969 101.081 131.699V131.699ZM101.081 107.484H80.3207V65.9739H101.081V107.484Z" />
            </svg>

            <h3>Your team is incomplete, instead to join solo</h3>
            <button
              className="btn primary"
              onClick={() => setIncompleteTeam(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GamesFeed;
